import React, { memo, useRef, useEffect } from "react";
import { extend, useThree, useFrame } from "react-three-fiber";
import gsap from "gsap";

import { EffectComposer } from "three/examples/jsm/postprocessing/EffectComposer";
import { ShaderPass } from "three/examples/jsm/postprocessing/ShaderPass";
import { RenderPass } from "three/examples/jsm/postprocessing/RenderPass";
import { UnrealBloomPass } from "three/examples/jsm/postprocessing/UnrealBloomPass";

import Blur from "shaders/blur";

extend({ EffectComposer, ShaderPass, RenderPass, UnrealBloomPass });

const MotionBlur = ({ index }) => {
  const { gl, scene, camera } = useThree();

  const prevIndex = useRef(index);
  const shaderPass = useRef();
  const composer = useRef();

  useFrame(() => composer.current.render(), 1);

  useEffect(() => {
    if (prevIndex.current !== index) {
      gsap.to(shaderPass.current.uniforms.delta.value, {
        duration: 1,
        keyframes: [{ y: 0.1 }, { y: 0 }]
      });

      prevIndex.current = index;
    }
  }, [index]);

  return (
    <effectComposer ref={composer} args={[gl]}>
      <renderPass attachArray="passes" scene={scene} camera={camera} />
      <shaderPass
        ref={shaderPass}
        attachArray="passes"
        args={[Blur, "texture"]}
        renderToScreen
      />
    </effectComposer>
  );
};

export default memo(MotionBlur);
